import Icon  from './Icon'

class Bubble extends Icon {
	icon: string
	studyId: string
	created(properties) {
		const toHTML = (icon) => {
			return icon.replace(/goo/, 'goo-' + properties.studyId)
		}
		properties.innerHTML = toHTML(properties.icon)
	}
}

export default Bubble